<template>
  <div class="datenschutz-container">
    <h1>Datenschutzerklärung</h1>

    <h2>1. Datenschutz auf einen Blick</h2>
    <h3>Allgemeine Hinweise</h3>
    <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p>

    <h2>2. Verantwortlicher</h2>
    <p>Verantwortlicher im Sinne der DSGVO ist:</p>
    <p>
      Facetronic UG (haftungsbeschränkt)<br>
      Vertreten durch: Anton Dieterich, Phil Ehrmann (Geschäftsführer)<br>
      Im Zukunftspark 4<br>
      74076 Heilbronn<br>
      Telefon: +49 7131 3859900<br>
      E-Mail: info@facetronic.de
    </p>
    <p>Datenschutzbeauftragte: Melanie Roth<br>
    E-Mail: <a href="mailto:info@datenschutz-roth.eu">info@datenschutz-roth.eu</a></p>

    <h2>3. Hosting und Server-Log-Dateien</h2>
    <h3>SSL- bzw. TLS-Verschlüsselung</h3>
    <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>

    <h3>Server-Log-Dateien</h3>
    <p>Der Hosting-Anbieter dieser Website erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
    <ul>
      <li>Browsertyp und Browserversion</li>
      <li>Verwendetes Betriebssystem</li>
      <li>Referrer URL</li>
      <li>Hostname des zugreifenden Rechners</li>
      <li>IP-Adresse</li>
      <li>Uhrzeit der Serveranfrage</li>
    </ul>
    <p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Dateien erfasst werden.</p>

    <h2>4. Datenerfassung auf dieser Website</h2>
    <h3>Wie erfassen wir Ihre Daten?</h3>
    <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in unser Kontaktformular eingeben.</p>
    <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>

    <h3>Wofür nutzen wir Ihre Daten?</h3>
    <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können nach Ihrer Einwilligung zur Analyse Ihres Nutzerverhaltens oder zur Anzeige personalisierter Werbung verwendet werden.</p>

    <h3>Kontaktformular</h3>
    <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular (Name, E-Mail-Adresse, Telefonnummer, Unternehmen, Nachricht) zur Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Die Daten werden über die HubSpot Forms API an HubSpot, Inc. (Anbieter: HubSpot, Inc., 25 First Street, Cambridge, MA 02141, USA; EU-Tochter: HubSpot Ireland Limited, Dublin) übermittelt und dort verarbeitet.</p>
    <p>Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen bzw. Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Kundenanfragen). Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind.</p>

    <h2>5. Cookies</h2>
    <p>Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.</p>

    <h3>Notwendige Cookies</h3>
    <p>Diese Cookies sind für den Betrieb der Website unbedingt erforderlich. Sie ermöglichen grundlegende Funktionen und Sicherheitsmerkmale der Website.</p>
    <ul>
      <li>Name: cookie_consent</li>
      <li>Zweck: Speichert Ihre Cookie-Einwilligungsentscheidung</li>
      <li>Speicherort: localStorage</li>
      <li>Dauer: Dauerhaft (bis zum manuellen Widerruf)</li>
    </ul>

    <h3>Einwilligung und Cookie-Banner</h3>
    <p>Beim ersten Besuch unserer Website werden Sie über unseren Cookie-Banner um Ihre Einwilligung gebeten. Sie können zwischen folgenden Kategorien wählen:</p>
    <ul>
      <li><strong>Notwendig:</strong> Technisch erforderliche Funktionen, die nicht deaktiviert werden können.</li>
      <li><strong>Analyse:</strong> Dienste zur Auswertung der Website-Nutzung (HubSpot Analytics).</li>
      <li><strong>Marketing:</strong> Dienste zur Anzeige personalisierter Werbung (Meta Pixel, Google Ads, HubSpot Marketing).</li>
      <li><strong>Externe Medien:</strong> Inhalte externer Anbieter wie Google Maps.</li>
    </ul>
    <p>Rechtsgrundlage für die Verarbeitung ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 TDDDG. Ohne Ihre Einwilligung werden keine nicht-notwendigen Cookies gesetzt und keine Daten an Drittanbieter übermittelt. Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen" in der Fußzeile unserer Website widerrufen oder anpassen. Der Widerruf berührt nicht die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung.</p>

    <h3>Marketing- und Analyse-Cookies</h3>
    <p>Die folgenden Dienste werden erst nach Ihrer ausdrücklichen Einwilligung geladen.</p>

    <h4>HubSpot</h4>
    <p>Wir nutzen HubSpot (Anbieter: HubSpot, Inc., 25 First Street, Cambridge, MA 02141, USA; EU-Tochter: HubSpot Ireland Limited, Dublin) für unser Marketing und die Analyse der Website-Nutzung. Das Tracking-Script wird erst nach Ihrer Einwilligung in die Kategorie „Marketing" geladen.</p>
    <ul>
      <li>Name: hubspotutk — Zweck: Tracking der Besucher-Session — Dauer: 13 Monate</li>
      <li>Name: __hssc — Zweck: Tracking der aktuellen Sitzung — Dauer: 30 Minuten</li>
      <li>Name: __hssrc — Zweck: Identifizierung neuer Sitzungen — Dauer: Sitzungsende</li>
    </ul>
    <p>Weitere Informationen: <a href="https://legal.hubspot.com/privacy-policy" target="_blank" rel="noopener noreferrer">HubSpot Datenschutzrichtlinie</a></p>

    <h4>Meta (Facebook) Pixel</h4>
    <p>Wir verwenden das Meta Pixel (Anbieter: Meta Platforms Ireland Ltd., 4 Grand Canal Square, Dublin 2, Irland), um die Wirksamkeit unserer Werbeanzeigen auf Facebook und Instagram zu messen. Das Pixel wird erst nach Ihrer Einwilligung in die Kategorie „Marketing" geladen. Dabei werden Daten (u. a. IP-Adresse, Browser-Informationen) an Meta übermittelt.</p>
    <ul>
      <li>Name: _fbp — Zweck: Speichert und verfolgt Besuche über Websites hinweg — Dauer: 3 Monate</li>
    </ul>
    <p>Weitere Informationen: <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">Meta Datenschutzrichtlinie</a></p>

    <h4>Google Ads (gtag.js)</h4>
    <p>Wir verwenden Google Ads Conversion-Tracking (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland), um die Wirksamkeit unserer Google-Werbeanzeigen zu messen. Das Script wird erst nach Ihrer Einwilligung in die Kategorie „Marketing" geladen.</p>
    <ul>
      <li>Name: _gcl_au — Zweck: Conversion-Tracking und Zuordnung von Werbeklicks — Dauer: 3 Monate</li>
    </ul>
    <p>Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Datenschutzrichtlinie</a></p>

    <h3>Externe Medien</h3>

    <h4>Google Maps</h4>
    <p>Wir verwenden Google Maps (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland), um Ihnen interaktive Karten anzuzeigen. Die Einbindung erfolgt erst nach Ihrer Einwilligung in die Kategorie „Externe Medien". Dabei werden Daten (u. a. IP-Adresse) an Google übermittelt.</p>
    <ul>
      <li>Name: NID — Zweck: Speichert Präferenzen und Informationen — Dauer: 6 Monate</li>
      <li>Name: 1P_JAR — Zweck: Personalisierung von Google-Diensten — Dauer: 1 Monat</li>
    </ul>
    <p>Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Datenschutzrichtlinie</a></p>

    <h2>6. Datenübermittlung in Drittländer</h2>
    <p>Einige der oben genannten Dienste (HubSpot, Meta, Google) können Daten in die USA oder andere Drittländer übermitteln. Die USA verfügen mit dem EU-U.S. Data Privacy Framework über einen Angemessenheitsbeschluss der EU-Kommission. Soweit die genannten Anbieter unter dem Data Privacy Framework zertifiziert sind, stützt sich die Datenübermittlung auf diesen Angemessenheitsbeschluss. Im Übrigen werden Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO als Grundlage für die Übermittlung herangezogen.</p>

    <h2>7. Ihre Rechte</h2>
    <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
    <ul>
      <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Sie haben das Recht, Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten.</li>
      <li><strong>Berichtigungsrecht</strong> (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger Daten verlangen.</li>
      <li><strong>Löschungsrecht</strong> (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, sofern die Voraussetzungen hierfür vorliegen.</li>
      <li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO): Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.</li>
      <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
      <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</li>
      <li><strong>Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO): Sie können eine erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Datenverarbeitung wird dadurch nicht berührt.</li>
    </ul>

    <h3>Beschwerderecht bei einer Aufsichtsbehörde</h3>
    <p>Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde zu, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt. Die für uns zuständige Aufsichtsbehörde ist:</p>
    <p>
      Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg<br>
      Lautenschlagerstraße 20<br>
      70173 Stuttgart<br>
      Telefon: +49 (0) 711 615541-0<br>
      E-Mail: poststelle@lfdi.bwl.de<br>
      Website: <a href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank" rel="noopener noreferrer">www.baden-wuerttemberg.datenschutz.de</a>
    </p>

    <h2>8. Kontakt</h2>
    <p>Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:</p>
    <p>Facetronic UG (haftungsbeschränkt)<br>
    Datenschutzbeauftragte: Melanie Roth<br>
    E-Mail: <a href="mailto:info@datenschutz-roth.eu">info@datenschutz-roth.eu</a><br><br>
    Facetronic UG (haftungsbeschränkt)<br>
    Im Zukunftspark 4<br>
    74076 Heilbronn<br>
    E-Mail: <a href="mailto:info@facetronic.de">info@facetronic.de</a></p>

    <h2>9. Änderungen</h2>
    <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.</p>
    <p class="stand">Stand: Februar 2026</p>
  </div>
</template>

<script>
export default {
  name: 'DatenschutzView'
}
</script>

<style scoped>
.datenschutz-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 80px;
}

h1 {
  color: var(--color-secondary);
  margin-bottom: 2rem;
}

h2 {
  color: var(--color-secondary);
  margin-bottom: 1rem;
}

h3 {
  color: var(--color-secondary);
  margin-bottom: 0.5rem;
}

p {
  line-height: 1.6;
  color: var(--color-text);
  margin-bottom: 2rem;
}

ul {
  color: var(--color-text);
  margin-bottom: 2rem;
  padding-left: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
}

h4 {
  color: var(--color-secondary);
  margin-bottom: 0.5rem;
}

.stand {
  color: var(--color-text-muted);
  font-size: 0.9em;
  font-style: italic;
}
</style> 